export default __webpack_public_path__ + "static/media/avatar.5c81ad97.png";